import ROUTES from '../constants';
import Pending from '../../../pages/Pending';
import Closing from '../../../pages/Closing';

export const redirect = new Map([
  [ROUTES.SELLING_PARKED, { to: ROUTES.TR4_SELL_PARKED, tr4: true }],
  [ROUTES.SELLING_UPCOMING, { to: ROUTES.TR4_SELL_UPCOMING, tr4: true }],
  [ROUTES.SELLING_ACTIVE, { to: ROUTES.TR4_SELL_ACTIVE, tr4: true }],
  [ROUTES.SELLING_WON, { to: ROUTES.TR4_SELL_WON, tr4: true }],
  [ROUTES.SELLING_ARRIVED, { to: ROUTES.TR4_SELL_ARRIVED, tr4: true }],
  [ROUTES.SELLING_DELIVERED, { to: ROUTES.TR4_SELL_DELIVERED, tr4: true }],
  [ROUTES.SELLING_LOST, { to: ROUTES.TR4_SELL_LOST, tr4: true }],
  [ROUTES.SELLING_ADESA, { to: ROUTES.TR4_SELL_ADESA, tr4: true }],
  [ROUTES.SELLING_PENDING, { to: ROUTES.TR4_SELL_PENDING, tr4: true }],
  [ROUTES.SELLING_CLOSING, { to: ROUTES.TR4_SELL_CLOSING, tr4: true }]
]);

export const routes = [
  {
    path: [ROUTES.SELLING_PENDING],
    Component: Pending,
    authenticated: true
  },
  {
    path: [ROUTES.SELLING_CLOSING],
    Component: Closing,
    authenticated: true
  }
];
